import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  NotificationResponse,
  NotificationStatus,
  NotificationsRequests,
} from 'src/requests/notifications.requests';
import { QueryKey } from 'src/utils/react-query';

export function useUpdateNotificationMutation() {
  const queryClient = useQueryClient();

  const { mutateAsync: updateNotification, isLoading } = useMutation({
    mutationFn: NotificationsRequests.updateNotification,
    onSuccess: (updatedNotification) => {
      queryClient.setQueryData<NotificationResponse>(
        [QueryKey.NOTIFICATIONS],
        (contents) => {
          if (contents) {
            contents.notifications = contents.notifications.map(
              (notification) =>
                notification._id === updatedNotification._id
                  ? { ...notification, status: NotificationStatus.READ }
                  : notification,
            );
            contents.unreadCount = contents.notifications.filter(
              (notification) =>
                notification.status === NotificationStatus.UNREAD,
            ).length;
          }

          return contents;
        },
      );
    },
  });

  return {
    updateNotification,
    isUpdating: isLoading,
  };
}
